
import {define} from "observable:runtime";
import asset1 from "../style.css?url";

const assets = new Map([
  ["../style.css", asset1]
]);

define(
  {
    root: document.getElementById(`cell-2`),
    expanded: [],
    variables: []
  },
  {
    id: 2,
    body: async (html,display) => {
const {createUI, installHashImportBanner, installThemeToggle} = await import("../lib/helpers.js").then((module) => {
  if (!("createUI" in module)) throw new SyntaxError(`export 'createUI' not found`);
  if (!("installHashImportBanner" in module)) throw new SyntaxError(`export 'installHashImportBanner' not found`);
  if (!("installThemeToggle" in module)) throw new SyntaxError(`export 'installThemeToggle' not found`);
  return module;
});
installThemeToggle({ html, display });
installHashImportBanner({ html, display });
const { codeEditor, canvasOutput } = createUI({ html });
return {createUI,installHashImportBanner,installThemeToggle,codeEditor,canvasOutput};
},
    inputs: ["html","display"],
    outputs: ["createUI","installHashImportBanner","installThemeToggle","codeEditor","canvasOutput"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-5`),
    expanded: [],
    variables: []
  },
  {
    id: 5,
    body: (view,codeEditor) => {
const code_points = view(codeEditor("canvas:coords-points", {
  value: `// Jeder Punkt: [name, x, y]
const points = [
  ["A", 0, 0],
  ["B", 100, 0],
  ["C", 0, 100],
  ["D", 200, 150],
  ["E", 275, 280],
]

ctx.font = "16px Arial"
for (const [name, x, y] of points) {
  // Der Punkt selbst (roter Kreis)
  ctx.fillStyle = "red"
  ctx.beginPath()
  ctx.arc(x, y, 5, 0, 2 * Math.PI)
  ctx.fill()

  // Die Beschriftung daneben
  ctx.fillStyle = "black"
  ctx.fillText(name + " (" + x + ", " + y + ")", x + 10, y + 20)
}`
}));
return {code_points};
},
    inputs: ["view","codeEditor"],
    outputs: ["code_points"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-6`),
    expanded: [],
    variables: []
  },
  {
    id: 6,
    body: (display,canvasOutput,code_points) => {
display(canvasOutput(code_points, { width: 500, height: 360 }));
},
    inputs: ["display","canvasOutput","code_points"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
